import React from "react";
import SpaceCanvas from "../components/SpaceCanvas";

const SpaceMap = () => {
    return (
        <div>
            <SpaceCanvas />
        </div>
    );
};

export default SpaceMap;
